<script>
  import { onMount, onDestroy, afterUpdate, createEventDispatcher } from 'svelte';

  export let threshold = 50;
  export let elementScroll = undefined;
  export let hasMore = true;
  export let isLoading = false;
  export let reverse = false;
  export let key;

  const dispatch = createEventDispatcher();

  let isLoadMore = false;
  let component;
  let updateRef = key;
  let lastScrollHeight;
  let hasResetScroll = false;

  /*
	=============
	Notes
	=============

	- key is there to update the scrolling measurement respective to list updates.
	  For instance, when list elemenets count changes.
	- hasResetScroll is there to prevent afterUpdate to change the scrollTop all the time.
	  When you request for new page items and then call reset method,
	  we need to remember that you've reset the scrolling so not to jump to the top of the list
	  when new items arrive and also reset this behaviour when you request for next page again.
	-
  */

  $: {
    if (component || elementScroll) {
      const element = getScrollElement();

      element.addEventListener('scroll', onScroll);
      element.addEventListener('resize', onScroll);
    }
  }
  const getScrollElement = () => {
    return elementScroll ? elementScroll : component.parentNode;
  };

  const onScroll = (e) => {
    const element = e.target;

    const offset = reverse
      ? e.target.scrollTop
      : e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop;

    if (offset <= threshold) {
      if (!isLoadMore && hasMore) {
        dispatch('loadMore');
        hasResetScroll = false;
      }
      isLoadMore = true;
    } else {
      isLoadMore = false;
    }
  };

  export const resetScroll = () => {
    const element = getScrollElement();
    if (reverse) {
      element.scrollTop = element.scrollHeight;
    } else {
      element.scrollTop = 0;
    }
    hasResetScroll = true;
  };

  onMount(() => {
    if (reverse) {
      const element = getScrollElement();
      element.scrollTop = element.scrollHeight;
      lastScrollHeight = element.scrollHeight;
    }
  });

  afterUpdate(() => {
    if (reverse) {
      if (updateRef !== key) {
        const element = getScrollElement();
        const currentScrollHeight = element.scrollHeight;

        if (!hasResetScroll) {
          element.scrollTop = currentScrollHeight - lastScrollHeight;
        } else {
          element.scrollTop = element.scrollHeight;
        }

        // Reset lifecycle will be reset after each update
        hasResetScroll = false;
        lastScrollHeight = currentScrollHeight;
        updateRef = key;
      }
    }
  });

  onDestroy(() => {
    if (component || elementScroll) {
      const element = getScrollElement();

      element.removeEventListener('scroll', null);
      element.removeEventListener('resize', null);
    }
  });
</script>

<div
  bind:this={component}
  style="width:0px"
/>
{#if isLoading}
  <slot />
{/if}
